import { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Graph from "./Graph"; 
import Graph from "../../../../common/graph";
import SingleGraph from "../../../../common/single-graph";
import {Tooltip, Box, Typography} from '@mui/material';
import { tooltipMap } from '../../../../common/constants';

const BrandPartnersDetail = ({ patrners, privillage, singleGraphList, SingleGraphData, graphData, width, patrnerId, currency }) => {
  let partner_slice_data = patrners.slice(1)

  const [showMoreIndex, setShowMoreIndex] = useState(0)

  const [indexGraph, setIndexGraph] = useState([]);
  const [partnerName, setPartnerName] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const user_logo = user?.user_logo || 'logo.svg';

  const handleClickedCard = (p_id, i) => {
    patrnerId(p_id)
    setShowMoreIndex(i)
    setPartnerName("")
  }

  // const sliderRef = useRef(null);

  let handleClickedIndex = (i) => {
    if (!indexGraph.includes(i)) {
      setIndexGraph([...indexGraph, i]);
      // setShowMoreIndex(i)
    }
    if (indexGraph.includes(i)) {
      const updatedIndexGraph = indexGraph.filter((value) => value !== i);
      setIndexGraph(updatedIndexGraph);
      // setShowMoreIndex(updatedIndexGraph)
    }
  };

  let handleRemoveIndex = (i, name) => {
    if (indexGraph.includes(i)) {
      const updatedIndexGraph = indexGraph.filter((value) => value !== i);
      setIndexGraph(updatedIndexGraph);
    }
    if (name == partnerName) {
      setPartnerName("")
    }
  };

  const handleSigleGraphId = (id, name, i) => {
    SingleGraphData(id)
    setPartnerName(name)
    setShowMoreIndex(i)
  }


  useEffect(() => {

    const transformText = (text) => {
      return text.split('_').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join(' ');
    };

    document.querySelectorAll('.cardMenu').forEach(element => {
      element.textContent = transformText(element.textContent);
    });

    document.querySelectorAll('.cardMenuData').forEach(element => {
      element.textContent = transformText(element.textContent);
    });

  }, [patrners, privillage]);

  let settings = {
    dots: false,
    arrows: true,
    speed: 500,
    slidesToShow: partner_slice_data.length == 2 ? 2 : 3,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 1000,
    initialSlide: 0,
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 667,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      }
    ]
  };

  console.log(indexGraph);
console.log(partner_slice_data);


  return (
    <>
      <div className="col-md-12 cards-wraper">
        <div className="fixed-slide">
          <div className="card-block active" style={{ width: `${width}%` }}>
            {!indexGraph.includes(0) &&
              ((partner_slice_data[0]?.advertiser_cost !== null && partner_slice_data[0]?.advertiser_cost !== 0 && partner_slice_data[0]?.advertiser_cost !== '0') &&
                (partner_slice_data[0]?.savings !== null && partner_slice_data[0]?.savings !== 0 && partner_slice_data[0]?.savings !== '0') &&
                (partner_slice_data[0]?.media_cost !== null && partner_slice_data[0]?.media_cost !== 0 && partner_slice_data[0]?.media_cost !== '0') &&
                (partner_slice_data[0]?.impressions !== null && partner_slice_data[0]?.impressions !== 0 && partner_slice_data[0]?.impressions !== '0')
              )
              && <i className="fa-solid fa-chart-line graph-icon" onClick={() => handleClickedIndex(0)}></i>}
            {indexGraph.includes(0) && <i className="fa-solid fa-rotate-left back-icon" onClick={() => handleRemoveIndex(0, patrners[0]?.name)}></i>}
            {!indexGraph.includes(0) && <div>
              <label className="currency">{patrners[0]?.currency_sign}</label>

              <figure>
                <img
                  src={user_logo}
                  alt="Partner Logo"
                  onError={(e) => {
                    e.target.src = `../../../assets/images/partner_img/tecreo.svg`;
                    e.target.alt = 'Image not available';
                  }}
                />
              </figure>
              <ul>
                {privillage.map((key) => (
                  <li key={key}>
                    {key == "cpm" &&  <span className="cardMenuecpm">eCPM : &nbsp;</span>}
                        {key != "cpm" &&  <span className="cardMenu">{key} : &nbsp; </span>}
                    <p className="margin-percent">
                    <span style={{display:'inline',fontWeight:'bold'}}>{patrners[0][key] && key != "impressions"&&patrners[0]?.currency_sign}</span>
                      <strong className="cardMenuData">{patrners[0][key]}</strong>
                      {key == "savings" && <label>({patrners[0]?.margin_percentage +`%`})</label>}
                      {key == "cpm" && patrners[0][key] > 0 && <label>(avg.)</label>}
                      &nbsp;
                      <Tooltip 
                        title={
                          <Box>
                            <Typography sx={{ fontWeight: 600, fontSize: "14px", textTransform:'capitalize'}}>
                            {tooltipMap?.[key]?.title}
                            </Typography>
                            <Typography sx={{ fontSize: "12px", opacity: 0.8 }}>
                            {tooltipMap?.[key]?.body}
                            </Typography>
                          </Box>
                        }
                        placement="top">
                        <i className="fa-solid fa-info-circle rounded" style={{ cursor: "pointer" }} ></i>
                      </Tooltip>
                    </p>
                  </li>
                ))}
                <li className={`${showMoreIndex === 0 ? 'active' : ''}`} onClick={() => handleClickedCard(0, 0)}>Show Deals</li>
              </ul>
            </div>}

            {indexGraph.includes(0) &&
              <div className="card-map text-center">
                <img src="../../../assets/images/partner_img/tecreo.svg" className="graph-logo" />
                <i className="fa-solid fa-up-right-and-down-left-from-center expand-icon" onClick={() => handleSigleGraphId(0, patrners[0]?.name, 0)}></i>
                <Graph graphData1={graphData} keyName={patrners[0]?.name} />

              </div>
            }

          </div>
        </div>

        <div className="slider-wrapper">
          <Slider {...settings}>
            {partner_slice_data.map((item, i) => (

              <div className="card-block active" key={i + 1}>
                {!indexGraph.includes(i + 1) &&

                  ((partner_slice_data[i]?.advertiser_cost !== null && partner_slice_data[i]?.advertiser_cost !== 0 && partner_slice_data[i]?.advertiser_cost !== '0') &&
                    (partner_slice_data[i]?.savings !== null && partner_slice_data[i]?.savings !== 0 && partner_slice_data[i]?.savings !== '0') &&
                    (partner_slice_data[i]?.media_cost !== null && partner_slice_data[i]?.media_cost !== 0 && partner_slice_data[i]?.media_cost !== '0') &&
                    (partner_slice_data[i]?.impressions !== null && partner_slice_data[i]?.impressions !== 0 && partner_slice_data[i]?.impressions !== '0')
                  )

                  && <i className="fa-solid fa-chart-line graph-icon" onClick={() => handleClickedIndex(i + 1)}></i>}

                {indexGraph.includes(i + 1) && <i className="fa-solid fa-rotate-left back-icon" onClick={() => handleRemoveIndex(i + 1, item.name)}></i>}
                {!indexGraph.includes(i + 1) && <div>
                  <label className="currency">{item?.currency_sign}</label>
                  <figure>
                    <img src={item?.logo_path} />
                  </figure>
                  <ul>
                    {privillage.map((key) => {
                      return <li key={key}>
                        {key == "cpm" &&  <span className="cardMenuecpm">eCPM : &nbsp;</span>}
                        {key != "cpm" &&  <span className="cardMenu">{key} : &nbsp; </span>}
                        
                        <p className="margin-percent">
                        <span style={{display:'inline',fontWeight:'bold'}}>{patrners[0][key] && key != "impressions"&&patrners[0]?.currency_sign}</span>

                          <strong className="cardMenuData">
                            {item[key]}
                          </strong>
                          {key == "savings" && <label>({patrners[i + 1]?.margin_percentage + `%`})</label>}
                          {key == "cpm" && item[key] > 0 && <label>(avg.)</label>}
                          </p>
                        {/* <strong className="cardMenuData">{item[key]}</strong> */}
                      </li>
                    })}
                    <li className={`${showMoreIndex === i + 1 ? 'active' : ''}`} onClick={() => handleClickedCard(item?.brand_id, i + 1)}>Show Deals</li>
                  </ul>
                </div>}
                {indexGraph.includes(i + 1) &&
                  <div className="card-map text-center">
                    <img src={item?.logo_path} className="graph-logo" />
                    <i className="fa-solid fa-up-right-and-down-left-from-center expand-icon" onClick={() => handleSigleGraphId(item.brand_id, item.name, i + 1)}></i>
                    <Graph graphData1={graphData} keyName={item.name} />

                  </div>
                }
              </div>
            ))}
          </Slider>
        </div>
      </div>
      {partnerName && partnerName != undefined &&
        <div className="col-md-12">
          <div className="single-graph-wraper">
            <SingleGraph graphData1={singleGraphList} />
          </div>
        </div>
      }
    </>
  );
}
export default BrandPartnersDetail;